<template>
    <div v-if="task.output" style="text-align: right">
        <a :href="task.output.xlsxUrl" v-if="task.output.xlsxUrl" target="_blank" class="btn blue" v-tooltip title="Excel 2007 ou superior" @click="done">
            <i class="fa fa-download"></i>
            Baixar arquivo Excel
        </a>
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            },
            done: {
                type: Function
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ExportReportV1.vue?a3b30570